export const METRICS_STATE = {
  NOT_LOADED: 'NOT_LOADED',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING',
  NO_DATA: 'NO_DATA',
  PARTIAL: 'PARTIAL',
  COMPLETE: 'COMPLETE'
}

// TODO: display reason for disabled metrics to the user
// export const METRICS_REASONS = {
//   optedOut: 'Your company is not opted in to display metrics',
//   attackNotSupported: 'Attack is not metrics ready'
// }

export function shouldMetricsPoll(metricsWithMeta) {
  const metricsState = metricsWithMeta.state
  return (
    metricsState === METRICS_STATE.NOT_LOADED ||
    metricsState === METRICS_STATE.PENDING ||
    metricsState === METRICS_STATE.PARTIAL
  )
}

export const isMetricsSupportedTargetType = (targetType = '') => {
  if (targetType === 'Host') {
    return true
  }

  return false
}

export const isMetricsSupportedCommand = (command = '') => {
  switch (command.toLowerCase()) {
    case 'memory':
    case 'cpu':
    case 'shutdown':
      return true
    default:
      return false
  }
}

export function attackSupportsMetrics(command, targetType) {
  return (
    isMetricsSupportedCommand(command) &&
    isMetricsSupportedTargetType(targetType)
  )
}

// Helper function to figure out of there are enough attack metrics to display
// a graph, which is defined as any line of the metrics having 2 or more
// datapoints
export const shouldDisplayAttackMetrics = (
  totalClients,
  clientsMetricsEnabledCount
) => {
  if (totalClients == null || clientsMetricsEnabledCount == null) return false

  // If we have clients in the attack not enabled for metrics, just don't
  // display metrics.
  return totalClients > 0 && clientsMetricsEnabledCount > 0
}
